import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  root: {
    height: 26,
    padding: 0,
    margin: 0
  },
  switchBase: {
    padding: 3,
    '&$checked': {
      transform: 'translateX(32px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#3859e3',
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '4px solid #fff'
    },
    '&.Mui-disabled': {
      '& $thumb': {
        backgroundColor: theme.palette.gray.muted
      },
      '& + $track': {
        backgroundColor: `${theme.palette.gray.light} !important`,
        opacity: 1,
        border: 'none'
      }
    }
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: 'none'
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#ADBBEB',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}));
